import React from 'react';
import Multiselect from '@rio-cloud/rio-uikit/Multiselect';
import { MultiselectProps } from '@rio-cloud/rio-uikit/Multiselect';
import { FormattedMessage } from 'react-intl';

interface MultiselectOTAProps {
    hasError?: boolean;
    label?: string;
}

const MultiSelectOTA: React.FC<MultiselectOTAProps & Partial<MultiselectProps<any>>> = (props) => {

    const { label, hasError, ...multiselectProps } = props;
    const highlightError = hasError ? 'form-group has-feedback has-error' : '';
    return (
        <>
            {label && <label className='control-label'>
                <FormattedMessage id={label}/>
            </label>}
            <div className={highlightError}>
                <Multiselect
                    {...multiselectProps}
                /></div>
            {props.hasError &&
                <div className={'form-group has-feedback has-error'}>
                        <span className='help-block'>
                        <span><FormattedMessage id='intl-msg:form:requiredField'/></span>
                        </span>
                </div>
            }</>
    );
};

export default MultiSelectOTA;
